export function OtaStatus() { return null }
